import { styled } from '@mui/material';
import { CoreDialogContent } from '@youscience/core';

export const sxStyles = {
  dialogWrap: {
    '.MuiPaper-root': {
      borderRadius: '12px',
      maxWidth: '590px',
      width: '100%',
    },
  },
};

export const StyledDialogContent = styled(CoreDialogContent)(() => ({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  gap: '1rem',
  padding: '2.5rem 1.5rem',
}));
